var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("Clientes por Tipo de Status")]),_c('div',{ref:"chart"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }